import { render, staticRenderFns } from "./WeiYuanCert.vue?vue&type=template&id=38137533&scoped=true&"
import script from "./WeiYuanCert.vue?vue&type=script&lang=js&"
export * from "./WeiYuanCert.vue?vue&type=script&lang=js&"
import style0 from "./WeiYuanCert.vue?vue&type=style&index=0&id=38137533&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38137533",
  null
  
)

export default component.exports